import { render, staticRenderFns } from "./LanguageDependentField.vue?vue&type=template&id=775884b4"
import script from "./LanguageDependentField.vue?vue&type=script&lang=js"
export * from "./LanguageDependentField.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports